import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from "@angular/platform-browser";

//H.W:  From http://yceffort.com/archives/1173

@Pipe({name: "safeHtml"})
export class SafeHtml implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {
  }
  transform(value: string) {
    var e = document.createElement('div');
    e.innerHTML = value;
    return this.sanitized.bypassSecurityTrustHtml(e.childNodes[0].nodeValue);
  }
}




// WEBPACK FOOTER //
// ./src/pipes/safeHTML.ts